const getters = {
  documentListUploaded(state) {
    return state.applicationSummary?.documentListUploaded;
  },
  referralCallbackUrl(state) {
    return state.applicationSummary?.referralCallbackUrl;
  },
  businessInfo(state) {
    return state.applicationSummary?.businessInfo;
  },
  personalInfo(state) {
    return state.applicationSummary?.personalInfo;
  },
  isAndroidUser() {
    return typeof GenericEpaylater !== 'undefined';
  },
  fullName(state) {
    return `${state.applicationSummary?.personalInfo?.firstName || ''} ${state.applicationSummary?.personalInfo?.lastName || ''}`.trim();
  },
  supportId(state) {
    return state.supportId || localStorage.getItem('supportId');
  },
  welcomeRewardsData(state) {
    return state.welcomeRewardsData;
  },
  businessAddressPresentFlag(state) {
    return state.businessAddressPresentFlag;
  },
  skippingGSTFlag(state) {
    return state.skippingGSTFlag;
  }
};
export default getters;
